import { createContext, useReducer } from 'react'
import { Action, ContextType } from '@/types/context'
import reducer, { PartnerGroupsActionTypes, PartnerGroupsState } from './reducer'

interface PropTypes {
  children: React.ReactNode
}

const initialState: PartnerGroupsState = {
  groupDetail: {
    data: null,
    isLoading: false
  }
}

const PartnerGrouopsContext = createContext<ContextType<PartnerGroupsState, Action<PartnerGroupsActionTypes>>>({
  ...initialState,
  dispatch: () => null
})

export const PartnerGroupsProvider = ({ children }: PropTypes) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return <PartnerGrouopsContext.Provider value={{ ...state, dispatch }}>
    {children}
  </PartnerGrouopsContext.Provider>

}

export default PartnerGrouopsContext
export { PartnerGroupsActionTypes }
